export const fakeSearchResults = [
    // Pre-populated example competitor, can be empty if starting with no data
    {
        name: "Competitor 1",
        description: "This is a description of competitor 1 which is quite long and it is a competitor of our company, this competitor is a big company and has a lot of customers.",
        url: "www.competitor1.com",
        image: "",
        linkedInUrl: ""
    },
    {
        name: "Competitor 2",
        description: "This is a description of competitor 2 which is quite long and it is a competitor of our company, this competitor is a big company and has a lot of customers.",
        url: "www.competitor2.com",
        image: "",
        linkedInUrl: ""
    },
    {
        name: "Competitor 3",
        description: "This is a description of competitor 3 which is quite long and it is a competitor of our company, this competitor is a big company and has a lot of customers.",
        url: "www.competitor3.com",
        image: "",
        linkedInUrl: ""
    }
]

